module.exports = __webpack_public_path__ + "media/images/search-e3137e9c4fcf8d58bc3a98b7ff28af24.png";